import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { ProductCardGridWithPadding } from './styledProductCard'
import { irem } from '../../utils'

export type ProductCardFooterProps = React.ComponentProps<typeof ProductCardGridWithPadding> & {
  //
}

export const ProductCardFooterContainer = styled(Grid)`
  ${props => props.theme.breakpoints.up('sm')} {
    padding-right: ${props => props.theme.typography.pxToRem(15)};
  }
    
    > * + * {
        margin-left: ${props => props.theme.typography.pxToRem(15)};
        
        ${props => props.theme.breakpoints.up('sm')} {
            margin-left: ${props => props.theme.typography.pxToRem(40)};
        }
    }
`

export const ProductCardFooter: React.FC<PropsWithChildren<ProductCardFooterProps>> = ({ children, ...props }) => {
  return (
    <Grid item { ...props }>
      <ProductCardFooterContainer container direction={'row'} alignItems={'center'} justifyContent={'flex-start'}>
        { children }
      </ProductCardFooterContainer>
    </Grid>
  )
}
